import React from 'react'
import { connect } from 'react-redux'
import PromotionLink from './PromotionLink'

export class PromotionContainer extends React.Component {
  render = () => {
    return <PromotionLink {...this.props} />
  }
}

export const mapStateToProps = state => {
  const { productStore } = state

  const promotions = productStore.data.promotions ? productStore.data.promotions.attributes.rewards : null

  const props = {
    promotions
  }

  return props
}

export default connect(mapStateToProps)(PromotionContainer)
